import { Component } from "react"
import PropTypes from "prop-types"
import { Checkbox, ListItemButton, ListItemText, ListItemIcon } from "@mui/material"

class WatchlistsMenuItem extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
  }

  onClick = () => {
    const { id, onClick } = this.props
    onClick(id)
  }

  render() {
    const { name, checked } = this.props
    return <ListItemButton component="li" onClick={this.onClick}>
      <ListItemIcon>
        <Checkbox className="watchlist-checkbox" disableRipple checked={checked} />
      </ListItemIcon>
      <ListItemText primary={name} />
    </ListItemButton>
  }
}

export default WatchlistsMenuItem
